module.exports = __webpack_public_path__ + "img/sophie-naert.49147ee2.jpg";